export const state = {
  // product: undefined,
  // products: []
  avis: {},
  aviss: [],
  pagination: {
    size: 10,
  },
};
